<template>
	<up-popup :round="10" :closeOnClickOverlay="props.maskClick" v-model:show="show" @open="onPopupOpen"
		@close="onClose" v-bind="props.popupProps">
		<view class="">
			<view class="header flex justify-between">
				<view class="left" @click="onLeftClick">
					<slot name="left" />
				</view>
				<view class="title">
					{{ props.title }}
				</view>
				<view class="close-btn">
					<up-icon name="close" @click="onClose"></up-icon>
				</view>
			</view>

			<view :class="['content', 'popup-content', ...contentClass]">
				<slot />
			</view>

			<view class="footer" v-if="showFooter">
				<up-button type="primary" size="large" shape="circle" class="mb-0" :text="btnText"
					@click="onConfirm"></up-button>
			</view>
		</view>
	</up-popup>
</template>

<script setup>
	import {
		ref,
		reactive,
		defineProps,
		defineEmits,
		onMounted,
		computed,
		watch
	} from 'vue'
	import {
		useI18n
	} from 'vue-i18n'
	const {
		t
	} = useI18n()

	const props = defineProps({
		modelValue: Boolean,
		title: String,
		btnText: String,
		showFooter: {
			type: Boolean,
			default: true
		},
		maskClick: {
			type: Boolean,
			default: true
		},
		popupProps: {
			type: Object,
			default: {}
		},
		contentClass: {
			type: Array,
			default: []
		},
	})
	const btnText = computed(() => props.btnText || t('common.confirm'))

	const emit = defineEmits(['open', 'onConfirm', 'onClose', 'update:modelValue', "onLeftClick"])

	const show = computed({
		get: () => props.modelValue,
		set: (v) => {
			emit('update:modelValue', v)
		}
	})

	const onPopupOpen = () => {
		emit('open')
	}

	const onClose = () => {
		emit('update:modelValue', false)
		emit('onClose')
	}

	const onLeftClick = () => {
		emit('onLeftClick')
	}

	const onConfirm = () => {
		emit('onConfirm')
	}
</script>

<style scoped>
	.header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 128rpx;
		padding: 0 40rpx;
	}
	
	.title {
		font-weight: bold;
	}

	.content {
		padding: 0 32rpx;
	}

	.footer {
		padding: 32rpx 1rem 64rpx;
	}
</style>